import { useReducer } from 'react'

import { useQuery } from '../../../lib/useQuery'
import { ThemeConvertor } from '../../../themes/theme-convertor'
import { useTheme } from '../../../themes/ThemeProvider.component'
import {
  Action,
  ActionKind,
  Route,
  RouteType,
  State,
} from '../../CanaryPageBuilder/types'

const init = ({ theme, ...state }: State): State => {
  return {
    theme: new ThemeConvertor({
      base: theme,
      theme: {},
    }).toTheme(),
    ...state,
  }
}

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case ActionKind.SetTheme:
      return {
        ...state,
        theme: new ThemeConvertor({
          base: state.theme,
          theme: action.payload,
        }).toTheme(),
      }
    case ActionKind.NAVIGATE:
      return {
        ...state,
        route: action.payload as Route,
      }
    default:
      return state
  }
}
const INITIAL_STATE: Partial<State> = {
  route: {
    entityType: RouteType.THEME,
    path: '/theme',
  },
}

export const useThemePreview = () => {
  const { theme: mainTheme } = useTheme()
  const query = useQuery()

  const [state, dispatch] = useReducer(
    reducer,
    {
      theme: mainTheme,
      route: {
        entityType: query.type || INITIAL_STATE.route.entityType,
        path: query.path || INITIAL_STATE.route.path,
      },
    },
    init,
  )

  return {
    state,
    dispatch,
  }
}
